import "../../table.css"; // CSS dosyasını import edin

const Tag = () => {
    return (
      <table className="table table-bordered">
      <tbody>
        <tr>
          <td><b>ISBN NUMARASI</b></td>
          <td >978-975-17-6094-4</td>
        </tr>
        <tr>
          <td><b>YAYIN NO</b></td>
          <td >600</td>
        </tr>
        <tr>
          <td><b>ESER ADI</b></td>
          <td >Türk Dünyası Ansiklopedisi</td>
        </tr>
        <tr>
          <td><b>YAYIMCI HUKUKÎ ADI</b></td>
          <td >Atatürk Araştırma Merkezi Başkanlığı</td>
        </tr>
        <tr>
          <td ><b>YAYIMCI MARKA ADI</b></td>
          <td >
            Atatürk Kültür Dil ve Tarih Yüksek Kurumu – Atatürk Araştırma Merkezi Başkanlığı
          </td>
        </tr>
        <tr>
          <td><b>YAYINLANDIĞI ORTAM TÜRÜ</b></td>
          <td >Elektronik Materyal</td>
        </tr>
        <tr>
          <td><b>YAYINLANDIĞI ORTAM</b></td>
          <td >Elektronik Kapak (Çevrim içi / Web tabanlı)</td>
        </tr>
        <tr>
          <td><b>ORTAM TÜRÜ</b></td>
          <td >Pdf</td>
        </tr>
        <tr>
          <td><b>ERİŞİME AÇILMA TARİHİ</b></td>
          <td >31.12.2024</td>
        </tr>
        <tr>
          <td><b>İNTERNETTE ERİŞİM ADRESİ</b></td>
          <td >
            <a href="https://turkdunyasiansiklopedisi.gov.tr" target="_blank">
              https://turkdunyasiansiklopedisi.gov.tr
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    )
}
export default Tag